import GuyOnTheFloor from '../assets/GuyOnTheFloor.png';
import { AppHeaderBackButton } from '@ace-clublabs/shared-component-library';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../shared/state';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { CLUB_PHONE_NUMBERS, ClubCodes } from '@ace-clublabs/payment-types';
import { UtagHelper } from '../utils/utagHelper';
import { ClubHelper, PolicyHelper } from '@ace-clublabs/payments-helper';
import CookieHelper from '../utils/cookieHelper';
import { ErrorType } from '../shared/types';
import { AppFlow } from '@lib/types';
import { ErrorComponent } from '@ace-clublabs/payments-component-library';

export interface ErrorPageProps {
  errorType?: ErrorType;
}
const ErrorPage: React.FC<ErrorPageProps> = (props) => {
  const navigate = useNavigate();
  const [_clubCode] = useGlobalState('clubCode');
  const [appFlow] = useGlobalState('appFlow');
  const [tagging, setIsTagging] = useState(true);
  const [membershipNumber] = useGlobalState('membershipNumber');

  const getClubCode = () => {
    const clubCodeFromZipCookie = CookieHelper.getClubCodeFromZipcodeCookie();
    if (_clubCode) return _clubCode;
    if (clubCodeFromZipCookie && clubCodeFromZipCookie !== '000') return clubCodeFromZipCookie;
    if (membershipNumber?.length === 16) return PolicyHelper.getClubCodeFromMemberNumber(membershipNumber);
    return '004';
  };
  const clubCode = getClubCode();

  const clubPhoneNumber = CLUB_PHONE_NUMBERS[clubCode];
  const isPaymentError = props?.errorType === ErrorType.PAYMENT_ERROR;

  const isSystemError = props?.errorType === ErrorType.SYSTEM_ERROR;

  const errorMessage = isPaymentError
    ? 'Sorry, there was a problem processing your payment'
    : isSystemError
    ? 'Our systems are temporarily unavailable'
    : 'The page you were looking for is no longer available';

  const onClickBackToStart = () => navigate(Pages.VerifyEligibility);

  useEffect(() => {
    const club = ClubHelper.getClubAcronym(clubCode as ClubCodes);
    const page = isPaymentError ? UtagHelper.Pages(appFlow).paymentError : UtagHelper.Pages(appFlow).error;
    const error = isPaymentError
      ? appFlow === AppFlow.AUTOPAY
        ? UtagHelper.Errors.autoPayFlowPaymentError
        : UtagHelper.Errors.paymentError
      : UtagHelper.Errors.systemError;
    UtagHelper.tag({
      ...UtagHelper.CommonTaggingValues(appFlow),
      club,
      page,
      error,
    });

    setIsTagging(false);
  }, []);

  if (tagging) {
    return <></>;
  }

  return (
    <>
      <AppHeaderBackButton id="back-button" onClick={onClickBackToStart} label="Back to start" />
      <ErrorComponent
        title={errorMessage}
        phoneNumber={clubPhoneNumber}
        imagePath={GuyOnTheFloor}
      ></ErrorComponent>{' '}
    </>
  );
};

export default ErrorPage;
